import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';

export interface AgreementOptionDTO {
  label: string;
  value: string;
}

interface FetchAgreementOptionsParams {
  campaignId: string | null;
}

const fetchAgreementOptions = async ({
  campaignId,
}: FetchAgreementOptionsParams): Promise<AgreementOptionDTO[]> =>
  authFetch(
    urlWithParams(
      '/Adviser/Campaigns/AgreementOptions',
      {
        campaignId,
      },
      { skipNulls: true },
    ),
  );

interface UseAgreementOptionsQueryParams {
  campaignId: string | null;
}

export const useAgreementOptionsQuery = ({ campaignId }: UseAgreementOptionsQueryParams) =>
  useQuery(queryKeys.agreementOptions(campaignId), () => fetchAgreementOptions({ campaignId }), {
    cacheTime: 0,
  });
